export default __webpack_public_path__ + "static/media/lock.aff1a901.svg";